define('views/modules/questionnaire/questionnaire-content',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/viewport',
    'services/i18n',
    // views
    'views/parts/menu/menu-action',
    'views/parts/list/fetch-list',
    'views/modules/questionnaire/list/questionnaire-list-item',
    'views/modules/questionnaire/edit/questionnaire-edit-panel',
    'views/modules/questionnaire/questions/questions-panel',
    'views/modules/member/select/member-select-panel',
    'views/modules/questionnaire/send-questionnaire-modal',
    'views/modules/questionnaire/questionnaire-link-modal',
    'views/parts/alert/alert-no-data',
    // models
    'collections/questionnaire/questionnaires',
    'collections/conversation/conversations',
    // templates
    'text!templates/modules/questionnaire/questionnaire-content.html'
], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    Viewport,
    i18n,
    // views
    VMenuAction,
    VFetchList,
    VQuestionnaireListItem,
    VQuestionnaireEditPanel,
    VQuestionsPanel,
    VMemberSelectPanel,
    VSendQuestionnaireModal,
    VQuestionnaireLinkModal,
    VAlertNoData,
    // models
    CQuestionnaires,
    CConversations,
    // templates
    TQuestionnaireContent
) {

    var VQuestionnaireContent = Backbone.View.extend({

        template: TQuestionnaireContent,

        regions: {
            root: ".questionnaire-content",
            menu: ".menu-actions",
            list: "#questionnaire-list",
            alert: ".alert-no-data"
        },

        initialize: function(opt) {
            this.options = opt || {};

            _.extend(this, {
                collection: new CQuestionnaires(),
                conversations: new CConversations(),
                group: opt.group,
                url: opt.url
            });

            var collection = this.collection,
                view = this.view = {
                    menu: new VMenuAction({
                        context: this,
                        onClick: this.onActionClick,
                        collection: new Backbone.Collection([
                            { route: '#', title: i18n.t('messages:tooltip-create-questionnaire'), itemClass: 'big-action', content: '<strong>+</strong>', skipTranslation: 'true', callback: this.onAddAction },
                        ]),
                        tooltip: {
                            container: this.regions.root,
                        }
                    }),
                    list: new VFetchList({
                        collection: collection,
                        item: VQuestionnaireListItem,
                        bottom: true,
                    }),
                    alert: new VAlertNoData({
                        title: 'questionnaire:Add a questionnaire',
                        subtitle: 'questionnaire:Click on plus',
                        collection: collection,
                        addClass: 'alert-arrow alert-arrow-left-top'
                    })
                };

            this.panel = {};

            this.listenTo(collection, {
                "questionnaire:click": this.onQuestionnaireClick,
                "questionnaire:edit": this.onQuestionnaireEdit,
                "questionnaire:post": this.onQuestionnairePost,
                "questionnaire:link": this.onQuestionnaireLink,
            });
        },

        render: function() {
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext()));

            this.generateZones();
            var view = this.view,
                zone = this.zone;

            this.assign(view.menu, zone.$menu)
                .assign(view.alert, zone.$alert)
                .assign(view.list, zone.$list);

            this.collection.getFirstPage();

            return this;
        },

        getEditPanel: function() {
            var view = this.panel,
                edit = view.edit;
            if (!edit) {
                edit = view.edit = new VQuestionnaireEditPanel({ group: this.group });
                this.listenTo(edit, {
                    'form:success': this.onFormSuccess,
                    'questionnaire:show-questions': this.onQuestionnaireClick
                });
            }
            return edit;
        },

        getQuestionsPanel: function() {
            var view = this.panel,
                panel = view.questions;
            if (!panel) {
                panel = view.questions = new VQuestionsPanel({
                    group: this.group,
                    url: this.url,
                });
                this.listenTo(panel, {
                    'questionnaire:post': this.onQuestionnairePost,
                    'questionnaire:link': this.onQuestionnaireLink
                });
            }
            return panel;
        },
        ////////////
        // events //
        ////////////

        onActionClick: function(e) {
            e.preventDefault();
        },

        onAddAction: function() {
            var panel = this.getEditPanel();
            panel.resetModel();
            this.trigger('panel:stack', panel);
        },

        onQuestionnaireClick: function(model) {
            var panel = this.getQuestionsPanel();
            panel.setModel(model);
            this.trigger('panel:stack', panel);
        },

        onQuestionnaireResults: function(model) {
            var panel = this.getQuestionsPanel();
            panel.setModel(model);
            panel.showResults();
            this.trigger('panel:stack', panel);
        },

        onQuestionnaireEdit: function(model) {
            var panel = this.getEditPanel();
            panel.setModel(model);
            this.trigger('panel:stack', panel);
        },

        onQuestionnaireLink: function(model) {
            var view = this.view,
                linkView = view.link;

            if (!linkView) {
                linkView = view.link = new VQuestionnaireLinkModal();
            }

            linkView.setModel(model)
                .render();
        },

        onQuestionnairePost: function(model) {
            var view = this.panel,
                panel = view.memberSelect;

            if (!panel) {
                panel = view.memberSelect = new VMemberSelectPanel();
                this.listenTo(panel, { 'selected:confirm': this.onSelectedConfirm });
            }

            this.questionnaireToPost = model;
            this.trigger('panel:stack', panel);
        },

        onSelectedConfirm: function(collection) {
            var modal = this.view.message || (this.view.message = new VSendQuestionnaireModal({
                callback: this.onSendQuestionnaireConfirm,
                context: this
            }));

            modal.setQuestionnaire(this.questionnaireToPost)
                .setSelectedUsers(collection)
                .show();
        },

        onFormSuccess: function(model) {
            this.collection.add(model.toJSON(), { merge: true });
        }

    });

    return VQuestionnaireContent;

});

